export function motivoBloqueioExclusaoTalhao(talhao = {}) {
  const possuiPlantios = Array.isArray(talhao.plantios) && talhao.plantios.length > 0;
  const possuiCiclo = Boolean(
    talhao.ciclo_atual
    || talhao.ultimo_ciclo
    || talhao.data_plantio
  );

  if (possuiPlantios || possuiCiclo) {
    return 'Este talhão não pode ser excluído porque possui plantio cadastrado ou histórico de plantio.';
  }
  if (talhao.temHistorico === true || talhao.tem_historico === true) {
    return 'Este talhão não pode ser excluído porque possui histórico vinculado.';
  }
  return '';
}

export function removerPlantioDoTalhaoOperacional(talhao = {}, plantioId) {
  const plantios = (talhao.plantios || []).filter(item => String(item.id) !== String(plantioId));
  const cicloAtual = plantios.find(item => item.status === 'ativo')
    || plantios.find(item => item.status === 'planejado')
    || null;
  const ultimoCiclo = plantios[0] || null;
  const cicloExibido = cicloAtual || ultimoCiclo;

  return {
    ...talhao,
    plantios,
    ciclo_atual: cicloAtual,
    ultimo_ciclo: ultimoCiclo,
    cultura: cicloExibido?.cultura || null,
    data_plantio: cicloExibido?.data_plantio || null,
    data_colheita: cicloExibido?.data_colheita || cicloExibido?.data_colheita_prevista || null,
    data_colheita_prevista: cicloAtual?.data_colheita_prevista || null,
    data_colheita_efetiva: cicloExibido?.data_colheita || null,
    temHistorico: talhao.temHistorico === true || plantios.length > 0,
  };
}
